export default __webpack_public_path__ + "static/media/SLD2-C.cc47eaa0.png";